module.exports = __webpack_public_path__ + "img/logo.a050a19a.png";